import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NaValidators } from './na-validators';

@Injectable({
  providedIn: 'root'
})
export class NaForm {
  constructor() {}

  /**
   * å¯ä¸ºç©º
   *
   * @param {*} [defaultValue]
   * @returns {FormControl}
   * @memberof NaForm
   */
  empty(defaultValue?: any): FormControl {
    return new FormControl(defaultValue, {
      validators: []
    });
  }

  /**
   * å¿è¾å­æ®µ
   *
   * @param {*} [defaultValue=null]
   * @returns {FormControl}
   * @memberof NaForm
   */
  required(defaultValue: any = null): FormControl {
    return new FormControl(defaultValue, {
      validators: [
        NaValidators.required,
      ]
      // æ¥åæ´æ°ç­ç¥AbstractControlï¼æå³çæ§ä»¶æ´æ°èªèº«çäºä»¶ï¼ 'change' | 'blur' | 'submit' Default value: 'change'
      // updateOn: 'blur'
    });
  }

  /**
   * å¯ç 
   *
   * @param {*} [defaultValue='']
   * @returns {FormControl}
   * @memberof NaForm
   */
  password(defaultValue: any = ''): FormControl {
    return new FormControl(defaultValue, {
      validators: [
        NaValidators.required,
        NaValidators.password(defaultValue)
      ]
    });
  }
}
